import React from 'react';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import { useRecoilState } from 'recoil';
import Select from 'components/select';
import { landingZoneData } from 'pages/app-profiles/store';

import LandingZoneStyle from '../../LandingZoneStyle';

const filter = createFilterOptions();
const EventHubVNet = ({ index }) => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [landingZoneForm, setLandingZoneForm] = useRecoilState(landingZoneData);
    const [options, setOptions] = React.useState([]);
    const [initOptions, setInitOptions] = React.useState([]);

    const vnetGetApi = useMutation((payload) =>
        axios.get(`${endPoints.landingZones.Vnet}/location/${payload?.region}/subscription/${payload?.subscriptionId}`, payload)
    );
    const setEventHubVnet = (vNet, vNetDetails) => {
        const form = { ...landingZoneForm };
        try {
            const result = form?.vnetSubnet?.map((item, i) => {
                let obj = { ...item };
                if (index === i) {
                    obj = {
                        ...obj,
                        vNet: vNet !== '' || vNet !== null ? vNet : null,
                        vNetDetails: vNetDetails !== null ? vNetDetails : null,
                        subnet: null,
                        subnetDetails: null,
                    };
                }
                return obj;
            });
            form.vnetSubnet = result;
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);
        }
        setLandingZoneForm(form);
    };

    const seldValueExistsInOptions = (value) => options.find((option) => value === option?.label);
    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.label)) {
            setEventHubVnet(selected?.label, selected);
        }
    };

    const resetOptions = () => {
        setOptions(initOptions);
        setEventHubVnet(null, null);
    };

    React.useEffect(() => {
        if (options?.length && options?.length > 0 && landingZoneForm?.vnetSubnet?.[index]?.vNet) {
            const vnet = options?.find((value) => landingZoneForm?.vnetSubnet?.[index]?.vNet === value?.label);
            if (vnet) {
                const form = { ...landingZoneForm };
                try {
                    const result = form.vnetSubnet.map((item, i) => {
                        let obj = { ...item };
                        if (index === i) {
                            obj = {
                                ...obj,
                                vNet: vnet?.label !== '' || vnet?.label !== null ? vnet?.label : null,
                                vNetDetails: vnet !== null ? vnet : null,
                            };
                        }
                        return obj;
                    });
                    form.vnetSubnet = result;
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e);
                }
                setLandingZoneForm(form);
            }
        }
    }, [options]);

    React.useEffect(() => {
        if (vnetGetApi?.isSuccess) {
            if (vnetGetApi?.data?.data) {
                const combinedValue = vnetGetApi?.data?.data?.map((app) => ({ label: app.name, value: app.name, resourceId: app?.resourceId }));
                setOptions(combinedValue);
                setInitOptions(combinedValue);
            }
        }
    }, [vnetGetApi?.isSuccess]);
    React.useEffect(() => {
        if (landingZoneForm?.region && landingZoneForm?.subscriptionDetails) {
            vnetGetApi.mutate({ region: landingZoneForm?.regionDetails?.value, subscriptionId: landingZoneForm?.subscriptionDetails?.id });
        } else if (!landingZoneForm) {
            resetOptions();
        }
    }, [landingZoneForm?.region, landingZoneForm?.subscriptionDetails]);

    React.useEffect(() => {
        if (landingZoneForm?.region?.code && landingZoneForm?.subscription?.id && landingZoneForm) {
            vnetGetApi.mutate({ region: landingZoneForm?.region?.code, subscriptionId: landingZoneForm?.subscription?.id });
        }
    }, [landingZoneForm?.region, landingZoneForm?.subscription?.id]);

    React.useEffect(() => {
        if (landingZoneForm?.isTouched && !landingZoneForm?.vnetSubnet?.[index]?.vNet) {
            setIsTouched(true);
        } else {
            setIsTouched(false);
        }
    }, [landingZoneForm?.vnetSubnet, landingZoneForm?.isTouched]);

    return (
        <>
            <Stack direction="row" alignItems="center" justifyContent="center">
                <Select
                    key="VNet"
                    noOptionsText="No options"
                    loading={vnetGetApi?.isLoading}
                    forcePopupIcon={false}
                    disabled={vnetGetApi?.isLoading || landingZoneForm?.dataClassification === 'Restricted'}
                    value={landingZoneForm?.vnetSubnet?.[index]?.vNet}
                    onChange={(_event, newValue) => {
                        if (typeof newValue === 'string') {
                            handleOnSelectChange(newValue);
                        } else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                            handleOnSelectChange(newValue.inputValue);
                        } else {
                            handleOnSelectChange(newValue);
                        }
                    }}
                    filterOptions={(optionValues, params) => filter(optionValues, params)}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demoVnet"
                    options={options}
                    getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === 'string') {
                            return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        // Regular option
                        return option.label;
                    }}
                    renderOption={(props, option) => (
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        <li {...props}>{option.label}</li>
                    )}
                    sx={LandingZoneStyle.select}
                    // freeSolo
                    disableClearable={false}
                    isRequired={isTouched}
                    label="VNet *"
                />
            </Stack>
        </>
    );
};

EventHubVNet.propTypes = {
    index: PropTypes.number,
};

EventHubVNet.defaultProps = {
    index: 0,
};

export default React.memo(EventHubVNet);
